/** https://github.com/ng-packagr/ng-packagr/issues/1655 */
export default void 0;
